import React, { useEffect, useState } from "react";
import queryString from "query-string";
import "./css/CourseData.css";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import DropDownIcon from "@material-ui/icons/ArrowDropDown";

function CourseData({ courseData }) {
  const [singleCourseData, setSingleCourseData] = useState([]);
  //   console.log(window.location.);
  const params = queryString.parse(window.location.search);
  //   console.log(params);
  const [scroll, setScroll] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const toggleScroll = () => {
      if (window.pageYOffset > 500) {
        setScroll(true);
      } else {
        setScroll(false);
      }
    };
    window.addEventListener("scroll", toggleScroll);
    return () => window.removeEventListener("scroll", toggleScroll);
  }, []);
  useEffect(() => {
    let data = courseData.filter((data) => data.id === params.id);
    //   data = data[0].content;
    setSingleCourseData(data[0].content);
    console.log(data);
  }, [courseData, params.id]);

  console.log(courseData);
  // const [show, setShow] = useState(true);
  const [showData, setShowData] = useState(false);
  const [embedLink, setEmbedLink] = useState("");
  const [id, setId] = useState("");

  const showClassData = (_id) => {
    setId(_id);
    setShowData((sData) => !sData);
  };

  const handleLink = (src) => {
    if (src) {
      setEmbedLink(src);
    }
    scrollToTop();
  };
  return (
    <>
      <div className="course-data">
        {/* {show && (
          <>
            <div className="course-data-category">
              <p>CATEGORY</p>
              <p
                style={{
                  cursor: "pointer",
                }}
                onClick={() => setShow(false)}
              >
                <VisibilityOffIcon />
              </p>
              <p>{params.name.toUpperCase()}</p>
            </div>

            <div className="course-data-top">
              <p>LEVEL</p>
              <p>{params.category.toUpperCase()}</p>
            </div>
          </>
        )} */}

        <div className="course-data-container">
          <div className="course-data-video">
            <iframe
              className="responsive-iframe"
              src={embedLink}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen={true}
            ></iframe>
            {/* <video controls src="https://www.youtube.com/embed/ghQL8mgObZI" /> */}
          </div>

          {singleCourseData.map((cd) => {
            if (cd.level === params.category) {
              console.log(cd.data);
              return (
                <div className="course-data-content">
                  {cd.data.map((_cd) => {
                    return (
                      <>
                        <div className="course-data-drop">
                          <div className="course-data-down">
                            <p>
                              Total Classes - <span>{_cd.source.length}</span>
                            </p>
                            <p>{_cd.topics}</p>
                          </div>
                          <div
                            style={{
                              marginRight: "20px",
                              cursor: "pointer",
                            }}
                            className="icon"
                            onClick={() => showClassData(_cd.id)}
                          >
                            <DropDownIcon fontSize="large" />
                          </div>
                        </div>
                        {_cd.source.map((cs) => {
                          console.log(_cd.source.length);
                          return (
                            <>
                              {showData && _cd.id === id && (
                                <>
                                  <div
                                    onClick={() => handleLink(cs.src)}
                                    className="course-data-classes"
                                  >
                                    <div className="course-data-class">
                                      <p>
                                        {cs.class}. <span>{cs.name}</span>
                                      </p>
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          );
                        })}
                      </>
                    );
                  })}
                </div>
              );
            }
          })}
        </div>
      </div>
    </>
  );
}

export default CourseData;
